export default {
  primaria: '#ecd405',
  primaria_fundo_claro: '#ccb400',
  secundaria: '#444454',
  terciara: '#444c5c',
  texto: '#27272f',
  titulo: '#998d33',
  titulo_claro: '#c3b022',
};
